import React from "react";
import { useNavigate } from "react-router-dom";
import Gif from "../../assets/gifs/404.gif";
import { ErrorImg, ErrorPageWrapper, HomeBtn } from "./style";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <ErrorPageWrapper>
      <ErrorImg src={Gif} alt="" />
      <HomeBtn onClick={() => navigate("/home")}>Home</HomeBtn>
    </ErrorPageWrapper>
  );
};
